import { Button, Dialog, Divider, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import LocalSeeIcon from '@mui/icons-material/LocalSee';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import baseURL from "../../configs/api";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Webcam from "react-webcam";
import useAuth from "../hooks/useAuth";
import { delete_fileUpload } from "../../services/appFileUpload";
import { branchTimezone } from "../../utils/summaryCalculation";
import { getAvailableVehiclesByVehicleClassIdAndByPickupDateAndReturnDate } from "../../services/Vehicle";
import { handleCapture } from "../../utils/covertTheBase64FormatIntoImage";
import useConfirm from "../hooks/useConfirm";
import CustomFormatDatePicker from "./CustomFormatDatePicker";
import { useTheme } from "../hooks/useTheme";
import colorConfigs from "../../configs/colorConfigs";
import moment from "moment";
import { CustomImagePopup } from "./CustomImagePopup";
import { replacedVehicle } from "../../services/rental";
import useGeneral from "../hooks/useGeneral";
import Cookies from "js-cookie";
import useTenant from "../hooks/useTenant";

type AddReplaceVehicleModalProps = {
    replaceVehicleIsOpen: boolean;
    setReplaceVehicleIsOpen: (value: boolean) => void;
    summaryData: any;
    setVehicleReplaceRefresh: (value: boolean) => void;
    availableVehicleClass: any[];
    returnLocationOptionsOfParticularBranch: any[];
    bookedVehicleData: any | null;
    checkInFiles: any[];
    vehicleReplacementCheckInFiles: any[];
    formattedCreatedAt: string;
    reservationId: number;
    isCompletedOrCancelled: boolean;
    preferredDateFormat: string;
    setPleaseWaitPopup: (value: boolean) => void;
}

const fuelLevelOptions: any = [];
for (let i = 0; i <= 8; i++) {
    fuelLevelOptions.push(<option key={i} value={i}>{i}</option>);
}

const currentDate = new Date();

const AddReplaceVehicleModal = ({
    replaceVehicleIsOpen,
    setReplaceVehicleIsOpen,
    summaryData,
    setVehicleReplaceRefresh,
    availableVehicleClass,
    returnLocationOptionsOfParticularBranch,
    bookedVehicleData,
    checkInFiles,
    vehicleReplacementCheckInFiles,
    formattedCreatedAt,
    reservationId,
    isCompletedOrCancelled,
    preferredDateFormat,
    setPleaseWaitPopup
}: AddReplaceVehicleModalProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { theme, themeStyles } = useTheme();
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { dateFormat }: any = useGeneral();
    const [isContinue, setIsContinue] = useState<boolean>(false);
    const [returnLocations, setReturnLocations] = useState<number>(0);
    const [fuelLevelAtPickup, setFuelLevelAtPickup] = useState<number>(0);
    const [odometerAtPickup, setOdometerAtPickup] = useState<string>("");
    const [fuelLevelAtReturn, setFuelLevelAtReturn] = useState<number>(0);
    const [odometerAtReturn, setOdometerAtReturn] = useState<string>("");
    const [isChargeFuelToClient, setIsChargeFuelToClient] = useState<boolean>(false);
    const [odometerShowSpan, setOdometerShowSpan] = useState<boolean>(false);
    const [returnDates, setReturnDates] = useState<string>("");
    const [returnTimes, setReturnTimes] = useState<string>("");
    const [recalculateRatesOnEarlyReturn, setRecalculateRatesOnEarlyReturn] = useState<boolean>(false);
    const [availableVehicle, setAvailableVehicle] = useState<any[]>([]);
    const [selectedVehicleClassId, setSelectedVehicleClassId] = useState<number>(0);
    const [selectedVehicle, setSelectedVehicle] = useState<number>(0);
    const [isFreeChange, setIsFreeChange] = useState<boolean>(true);
    const [newVehicleFuleLevel, setNewVehicleFuleLevel] = useState<number>(0);
    const [newVehicleOdometer, setNewVehicleOdometer] = useState<string>("");
    const [returnVehicleFilePath, setReturnVehicleFilePath] = useState<any[]>([]);
    const [returnVehiclefileIndex, setReturnVehiclefileIndex] = useState<number>(-1);
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const [newVehicleFilePath, setNewVehicleFilePath] = useState<any[]>([]);
    const [newVehicleFileIndex, setNewVehicleFileIndex] = useState<number>(-1);

    const returnInputFileRef = useRef<HTMLInputElement>(null);
    const newInputFileRef = useRef<HTMLInputElement>(null);
    const webRef = useRef(null);

    const [returnVehicleNewFilePath, setReturnVehicleNewFilePath] = useState<any[]>([]);
    const [NewVehicleNewFilePath, setNewVehicleNewFilePath] = useState<any[]>([]);
    const [showWebcam, setShowWebcam] = useState<boolean>(false);
    const [currentWebCam, setCurrrentWebCam] = useState<string>("");
    const [currentPreview, setCurrrentPreview] = useState<string>("");
    const [comment, setComment] = useState<string>("");
    const [returnInfoMessage, setReturnInfoMessage] = useState<string>("");
    const [newInfoMessage, setNewInfoMessage] = useState<string>("");

    const UpdateTimezone = branchTimezone(formattedCreatedAt);
    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";

    useEffect(() => {
        if (summaryData?.isVehicleReplaced) {
            const checkinOldFiles = vehicleReplacementCheckInFiles?.filter((item: any) =>
                parseInt(item?.tabName?.replace("Checkin-VehicleReplacement-", "")) === summaryData?.id
            );

            setReturnVehicleFilePath(
                checkinOldFiles?.map((item: any) => ({
                    id: item.id,
                    fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
                }))
            );

        } else {
            setReturnVehicleFilePath(
                checkInFiles?.map((item: any) => ({
                    id: item.id,
                    fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
                }))
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkInFiles, summaryData, vehicleReplacementCheckInFiles])

    useEffect(() => {
        setReturnDates(currentDate?.toISOString()?.split("T")[0]);
        setReturnTimes(format(currentDate, "kk:mm"));
        setReturnLocations(summaryData?.returenLoationId);
        setOdometerAtPickup(summaryData?.odometerAtCheckOut);
        setFuelLevelAtPickup(summaryData?.fuelLevelAtCheckOut);
        setSelectedVehicleClassId(summaryData?.vehicleClassId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summaryData, replaceVehicleIsOpen])

    useEffect(() => {
        if (parseInt(odometerAtReturn) < Number(odometerAtPickup)) {
            setOdometerShowSpan(true);
        } else {
            setOdometerShowSpan(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [odometerAtReturn]);

    useEffect(() => {
        if (selectedVehicleClassId > 0) {
            let latestPickup = moment().format('YYYY-MM-DDTHH:mm');
            let latestReturn = moment().format('YYYY-MM-DDTHH:mm');
            latestPickup = moment(`${summaryData?.pickupDate}`).format('YYYY-MM-DDTHH:mm');
            latestReturn = moment(`${summaryData?.returnDate}`).format('YYYY-MM-DDTHH:mm');

            getAvailableVehiclesByVehicleClassIdAndByPickupDateAndReturnDate(
                selectedVehicleClassId,
                latestPickup,
                latestReturn,
                tenantId
            )
                .then((data) => {
                    setAvailableVehicle(
                        data?.map((item: any) => {
                            return {
                                value: item.id,
                                label: item.name,
                                vehicleClassId: item?.vehicleClassId,
                                fuel: item.fuelLevel,
                                odometer: item.odometer
                            }
                        })
                    );

                    setSelectedVehicle(0);
                    setNewVehicleOdometer('0');
                    setNewVehicleFuleLevel(0);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setSelectedVehicle(0);
                    setNewVehicleOdometer('0');
                    setNewVehicleFuleLevel(0);
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVehicleClassId])

    useEffect(() => {
        if (selectedVehicle > 0 && availableVehicle?.length > 0) {
            setNewVehicleOdometer(availableVehicle?.filter((item: any) => item.value === selectedVehicle)[0]?.odometer)
            setNewVehicleFuleLevel(availableVehicle?.filter((item: any) => item.value === selectedVehicle)[0]?.fuel)
        } else {
            setNewVehicleOdometer("");
            setNewVehicleFuleLevel(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVehicle, availableVehicle])

    const onReturnVehicleFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWaitPopup(true);

        const selectedFiles = e.target.files as FileList;

        if (selectedFiles?.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}reservationFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    const newFilePath: any = {
                        id: 0,
                        fileName:
                            `${baseURL}reservationFile/Get?name=` +
                            response.data,
                    };

                    setReturnVehicleNewFilePath((prevPath: string[]) => [
                        ...prevPath,
                        newFilePath.fileName,
                    ]);
                    setReturnVehicleFilePath((prevPath: any[]) => [...prevPath, newFilePath]);
                    setPleaseWaitPopup(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        } else {
            setPleaseWaitPopup(false);
        }
    }

    const onNewVehicleFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWaitPopup(true);

        const selectedFiles = e.target.files as FileList;

        if (selectedFiles?.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}reservationFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    const newFilePath: any = {
                        id: 0,
                        fileName:
                            `${baseURL}reservationFile/Get?name=` +
                            response.data,
                    };

                    setNewVehicleNewFilePath((prevPath: string[]) => [
                        ...prevPath,
                        newFilePath.fileName,
                    ]);
                    setNewVehicleFilePath((prevPath: any[]) => [...prevPath, newFilePath]);
                    setPleaseWaitPopup(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        } else {
            setPleaseWaitPopup(false);
        }
    }

    const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
        setPleaseWaitPopup(true);

        const selectedFiles = e.target.files as FileList;
        if (selectedFiles?.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);
            axios
                .post(`${baseURL}reservationFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    if (currentPreview === 'return-vehicle') {
                        setReturnVehicleFilePath((prevPath: any[]) =>
                            prevPath?.map(file =>
                                file.id === id ? {
                                    ...file,
                                    fileName: `${baseURL}reservationFile/Get?name=` + response?.data,
                                } : file
                            )
                        );
                    } else {
                        setNewVehicleFilePath((prevPath: any[]) =>
                            prevPath.map(file =>
                                file.id === id ? {
                                    ...file,
                                    fileName: `${baseURL}reservationFile/Get?name=` + response?.data,
                                } : file
                            )
                        );
                    }

                    setPleaseWaitPopup(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        } else {
            setPleaseWaitPopup(false);
        }
    }

    const showWarningMessageOnNoImage = () => {
        let summary = 'Are you sure you want to continue without image?';

        if (returnVehicleFilePath?.length <= 0) {
            summary += ' - Replace Vehicle Check In Image';
        }

        if (NewVehicleNewFilePath?.length <= 0) {
            summary += ' - Replacement Vehicle Check Out Image';
        }

        setConfirmData({
            title: 'Confirm for Vehicle Replacement',
            summary: summary,
            confirmBtn: 'Continue without image',
            isConfirm: (callback: any) => {
                setIsContinue(true);
                replacedTheVehicle();
                callback();
            }
        });

        setConfirmPopup(true);
    }

    const handleSubmit = () => {
        if (odometerAtReturn >= odometerAtPickup && returnLocations > 0) {
            setReturnInfoMessage("")
            if (selectedVehicleClassId > 0 && selectedVehicle > 0 && parseInt(newVehicleOdometer) > 0) {
                setNewInfoMessage("")

                if (!isContinue && (returnVehicleFilePath?.length <= 0 || NewVehicleNewFilePath?.length <= 0)) {
                    showWarningMessageOnNoImage();
                    return;
                }

                replacedTheVehicle();
            } else {
                setNewInfoMessage("*Please fill the complete new vehicle information.")
            }
        } else {
            setReturnInfoMessage("*Please fill the complete return information.")
        }
    }

    const replacedTheVehicle = () => {
        let vehicleClassId = summaryData?.vehicleClassId;

        if (parseInt(vehicleClassId) !== selectedVehicleClassId) {
            const newSelectedVehicle = availableVehicleClass?.find((item: any) => item?.vehicleClassId === selectedVehicleClassId);
            if (newSelectedVehicle?.availableVehicles <= 0) {
                let latestPickup = moment().format('YYYY-MM-DDTHH:mm');
                let latestReturn = moment().format('YYYY-MM-DDTHH:mm');
                latestPickup = moment(`${summaryData?.pickupDate}`).format('YYYY-MM-DDTHH:mm');
                latestReturn = moment(`${summaryData?.returnDate}`).format('YYYY-MM-DDTHH:mm');

                setConfirmData({
                    title: `Between ${moment(latestPickup)?.format(dateFormat + " hh:mm A")} - ${moment(latestReturn)?.format(dateFormat + " hh:mm A")} dates selected vehicle is not available`,
                    summary: '',
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setTimeout(() => setConfirmPopup(true), 0);

                return;
            } else {
                updateTheFiles();
            }
        } else {
            updateTheFiles();
        }
    }

    const updateTheFiles = () => {
        setPleaseWaitPopup(true);
        let files: any[] = [];

        if (returnVehicleNewFilePath?.length > 0) {
            returnVehicleNewFilePath?.forEach((item: string, index: number) => {
                files.push({
                    attributeName: "Reservation",
                    attributeId: reservationId,
                    fileName: item?.replace(
                        `${baseURL}reservationFile/Get?name=`,
                        ""
                    ),
                    tabName: summaryData?.isVehicleReplaced ? `Checkout-VehicleReplacement-${summaryData?.id}` : "Checkin",
                    userId: auth?.id ?? 0,
                    createdDate: new Date(UpdateTimezone).toLocaleString()
                });

                if (returnVehicleNewFilePath?.length - 1 === index) {
                    updateTheVehicleReplacedFile(files)
                }
            });
        } else {
            updateTheVehicleReplacedFile(files)
        }
    }

    const updateTheVehicleReplacedFile = (files: any[]) => {
        let replacedFiles: any[] = [];
        if (NewVehicleNewFilePath?.length > 0) {
            NewVehicleNewFilePath?.forEach((item: string, index: number) => {
                replacedFiles.push({
                    attributeName: "Reservation",
                    attributeId: reservationId,
                    fileName: item?.replace(
                        `${baseURL}reservationFile/Get?name=`,
                        ""
                    ),
                    tabName: "",
                    userId: auth?.id ?? 0,
                    createdDate: new Date(UpdateTimezone).toLocaleString()
                });

                if (newVehicleFilePath?.length - 1 === index) {
                    addNewVehicleReplace(files, replacedFiles);
                }
            });
        } else {
            addNewVehicleReplace(files, replacedFiles);
        }
    }

    const addNewVehicleReplace = (files: any[], replacedFiles: any[]) => {
        if (isCompletedOrCancelled) return;

        replacedVehicle(
            {
                returnLocationId: returnLocations,
                fuelLevel: fuelLevelAtReturn,
                isChargeFuelToClient: isChargeFuelToClient,
                odometer: odometerAtReturn,
                returnDate: returnDates + "T" + returnTimes,
                isRecalculateRatesOnEarlyReturn: recalculateRatesOnEarlyReturn,
                fileUploadDataDtos: files,
                replaceVehicleClassId: selectedVehicleClassId,
                replaceVehicleId: selectedVehicle,
                isFreeChanged: isFreeChange,
                replaceVehicleFuelLevel: newVehicleFuleLevel,
                replaceVehicleOdometer: newVehicleOdometer,
                replaceVehicleFileUploadDataDtos: replacedFiles,
                comment: comment?.trim()

            },
            reservationId,
            auth?.id,
            tenantId
        )
            .then(() => {
                setVehicleReplaceRefresh(true);
                setReplaceVehicleIsOpen(false);
                resetTheForm();
                handleTenantError(null);
            })
            .catch(error => {
                setPleaseWaitPopup(false);
                setConfirmData({
                    title: 'Warning',
                    summary: error.response.data,
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);
                handleTenantError(error);
            });
    }

    const resetTheForm = () => {
        setIsContinue(false);
        setReturnLocations(0);
        setFuelLevelAtPickup(0);
        setOdometerAtPickup("");
        setFuelLevelAtReturn(0);
        setOdometerAtReturn("");
        setIsChargeFuelToClient(false);
        setOdometerShowSpan(false);
        setReturnDates("");
        setReturnTimes("");
        setRecalculateRatesOnEarlyReturn(false);
        setSelectedVehicleClassId(0);
        setSelectedVehicle(0);
        setIsFreeChange(true);
        setNewVehicleFuleLevel(0);
        setNewVehicleOdometer("");
        setReturnVehicleFilePath([]);
        setReturnVehiclefileIndex(-1);
        setNewVehicleFilePath([]);
        setNewVehicleFileIndex(-1);
        setReturnVehicleNewFilePath([]);
        setNewVehicleNewFilePath([]);
        setComment("");
        setReturnInfoMessage("");
        setNewInfoMessage("");
    }


    return (
        <>
            <Dialog
                open={replaceVehicleIsOpen}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '724px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                        onClick={() => setReplaceVehicleIsOpen(false)}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>

                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Vehicle Replacement</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div>
                                            <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                                                Return Information
                                            </span>

                                            <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                            <div className="grid grid-cols-2 gap-6">
                                                <div>
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Link</label>
                                                        <br />
                                                        <span
                                                            className={`text-xs font-medium underline text-[#0000ff] cursor-pointer`}
                                                            onClick={() => {
                                                                if (bookedVehicleData) {
                                                                    navigate("/fleet/vehicle/editvehicles", {
                                                                        state: bookedVehicleData?.id,
                                                                    })
                                                                }
                                                            }}
                                                        >
                                                            {bookedVehicleData?.name ?? ""}
                                                        </span>
                                                    </div>

                                                    <div className="mt-[27px]">
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fuel level at Pickup</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{`${fuelLevelAtPickup} / 8`}</span>
                                                    </div>

                                                    <div className="mt-[19px]">
                                                        <div className="flex justify-between gap-x-[0.5rem]">
                                                            <div>
                                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fuel level at Return</label>
                                                                <select
                                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                    value={fuelLevelAtReturn}
                                                                    onChange={(e) =>
                                                                        setFuelLevelAtReturn(parseInt(e.target.value))
                                                                    }
                                                                    required
                                                                >
                                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>0</option>
                                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={1}>1</option>
                                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={2}>2</option>
                                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={3}>3</option>
                                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={4}>4</option>
                                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={5}>5</option>
                                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={6}>6</option>
                                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={7}>7</option>
                                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={8}>8</option>
                                                                </select>
                                                            </div>

                                                            <div>
                                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Charge fuel to client?</label>
                                                                <RadioGroup
                                                                    row
                                                                    value={isChargeFuelToClient ? "Yes" : "No"}
                                                                    onChange={(e) => setIsChargeFuelToClient(e.target.value === "Yes" ? true : false)}
                                                                >
                                                                    <FormControlLabel
                                                                        value="Yes"
                                                                        control={
                                                                            <Radio
                                                                                sx={{
                                                                                    color: "gray",
                                                                                    "&.Mui-checked": {
                                                                                        color: "#167AC3",
                                                                                    },
                                                                                    '& .MuiSvgIcon-root': {
                                                                                        fontSize: 14,
                                                                                    },
                                                                                }}
                                                                            />
                                                                        }
                                                                        label="Yes"
                                                                        sx={{
                                                                            color: themeStyles.form.labelTextColor
                                                                        }}
                                                                    />

                                                                    <FormControlLabel
                                                                        value="No"
                                                                        control={
                                                                            <Radio
                                                                                sx={{
                                                                                    color: "gray",
                                                                                    "&.Mui-checked": {
                                                                                        color: "#167AC3",
                                                                                    },
                                                                                    '& .MuiSvgIcon-root': {
                                                                                        fontSize: 14,
                                                                                    },
                                                                                }}
                                                                            />
                                                                        }
                                                                        label="No"
                                                                        sx={{
                                                                            color: themeStyles.form.labelTextColor
                                                                        }}
                                                                    />
                                                                </RadioGroup>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="mt-[19px]">
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Date</label>
                                                        <CustomFormatDatePicker
                                                            value={returnDates}
                                                            onChange={setReturnDates}
                                                            dateFormat={dateFormat}
                                                            minDate={
                                                                summaryData?.dateTimeCheckOut
                                                                    ? moment(summaryData?.dateTimeCheckOut)?.format('YYYY-MM-DD')
                                                                    : ""
                                                            }
                                                            required={true}
                                                        />
                                                    </div>

                                                    <div className="mt-[19px]">
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Recalculate rates on early Return?</label>
                                                        <RadioGroup
                                                            row
                                                            value={recalculateRatesOnEarlyReturn ? "Yes" : "No"}
                                                            onChange={(e) => setRecalculateRatesOnEarlyReturn(e.target.value === "Yes" ? true : false)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes"
                                                                control={
                                                                    <Radio
                                                                        sx={{
                                                                            color: "gray",
                                                                            "&.Mui-checked": {
                                                                                color: "#167AC3",
                                                                            },
                                                                            '& .MuiSvgIcon-root': {
                                                                                fontSize: 14,
                                                                            },
                                                                        }}
                                                                    />
                                                                }
                                                                label="Yes"
                                                                sx={{
                                                                    color: themeStyles.form.labelTextColor
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="No"
                                                                control={
                                                                    <Radio
                                                                        sx={{
                                                                            color: "gray",
                                                                            "&.Mui-checked": {
                                                                                color: "#167AC3",
                                                                            },
                                                                            '& .MuiSvgIcon-root': {
                                                                                fontSize: 14,
                                                                            },
                                                                        }}
                                                                    />
                                                                }
                                                                label="No"
                                                                sx={{
                                                                    color: themeStyles.form.labelTextColor
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Location</label>
                                                        <select
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={returnLocations}
                                                            onChange={(e) => setReturnLocations(parseInt(e.target.value))}
                                                            required
                                                        >
                                                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>{"None"}</option>
                                                            {
                                                                returnLocationOptionsOfParticularBranch?.map((item: any, index: number) => {
                                                                    return <option className={`${themeStyles.main.tailwindSectionBg}`} key={index} value={item.value}>{item.label}</option>;
                                                                })
                                                            }
                                                        </select>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Odometer at Pickup</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{odometerAtPickup}</span>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Odometer at Return</label>
                                                        <input
                                                            type="number"
                                                            min={summaryData ? summaryData?.odometerAtCheckOut : 0}
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={odometerAtReturn}
                                                            onChange={(e) => setOdometerAtReturn(e.target.value)}
                                                            required
                                                        />
                                                        <br />
                                                        {
                                                            odometerShowSpan && (
                                                                <span className="w-full text-xs text-red-500">*Must be getter than Odometer at Pickup</span>
                                                            )
                                                        }
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Time</label>
                                                        <input
                                                            type="time"
                                                            min={summaryData ? summaryData?.odometerAtCheckOut : 0}
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={returnTimes}
                                                            onChange={(e) => setReturnTimes(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mt-4 mb-2 w-full">
                                                <div className="max-w-1/2 flex flex-row items-center gap-[5px] flex-wrap">
                                                    {
                                                        returnVehicleFilePath?.map((item: any, outerIndex: number) => (
                                                            <React.Fragment key={outerIndex}>
                                                                <img
                                                                    src={item.fileName}
                                                                    width={40}
                                                                    height={40}
                                                                    alt="repairOrder"
                                                                    onClick={() => {
                                                                        setReturnVehiclefileIndex(outerIndex);
                                                                        setImagePopup(true);
                                                                        setCurrrentPreview('return-vehicle');
                                                                    }}
                                                                />

                                                                <RemoveCircleIcon
                                                                    className={`text-[14px] ${themeStyles.main.textSubHeadingColor} font-bold  hover:text-red-500 cursor-pointer`}
                                                                    onClick={() => {
                                                                        setConfirmData({
                                                                            title: 'Delete image',
                                                                            summary: "Are you sure you want to delete this image?",
                                                                            confirmBtn: 'Yes',
                                                                            isConfirm: async (callback: any) => {
                                                                                let newFileSet: any[] = returnVehicleFilePath.filter(
                                                                                    (_, index: number) => index !== outerIndex
                                                                                );

                                                                                if (returnVehicleFilePath[outerIndex].id === 0) {
                                                                                    setReturnVehicleFilePath(() => newFileSet);
                                                                                } else {
                                                                                    setPleaseWaitPopup(true);

                                                                                    delete_fileUpload(returnVehicleFilePath[outerIndex]?.id, auth?.id, tenantId)
                                                                                        .then(() => {
                                                                                            setReturnVehicleFilePath(() => newFileSet);
                                                                                            setPleaseWaitPopup(false);
                                                                                            handleTenantError(null);
                                                                                        })
                                                                                        .catch((error) => {
                                                                                            setPleaseWaitPopup(false);
                                                                                            handleTenantError(error);
                                                                                        });
                                                                                }

                                                                                callback();
                                                                            }
                                                                        });
                                                                        setConfirmPopup(true);
                                                                    }}
                                                                />
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images</label>
                                                    <input
                                                        type="file"
                                                        name="inputFileRef"
                                                        accept="image/*"
                                                        ref={returnInputFileRef}
                                                        onChangeCapture={onReturnVehicleFileChangeCapture}
                                                        style={{ display: "none" }}
                                                    />
                                                    <div className="flex flex-row gap-2 mt-2">
                                                        <p
                                                            className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                            onClick={() => {
                                                                if (returnInputFileRef.current) {
                                                                    returnInputFileRef.current.value = "";
                                                                }

                                                                returnInputFileRef.current?.click();
                                                            }}
                                                        >
                                                            <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                            Add Image
                                                        </p>

                                                        <p
                                                            className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                            onClick={() => {
                                                                setShowWebcam(true)
                                                                setCurrrentWebCam('return-vehicle')
                                                            }}
                                                        >
                                                            <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <span className="w-full text-xs text-red-500">{returnInfoMessage}</span>

                                            <div className="mt-4">
                                                <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                                                    New Vehicle
                                                </span>

                                                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                                <div className="grid grid-cols-2 gap-6">
                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>New Vehicle Class</label>
                                                            <select
                                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                value={selectedVehicleClassId}
                                                                onChange={(e) =>
                                                                    setSelectedVehicleClassId(parseInt(e.target.value))
                                                                }
                                                                required
                                                            >
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>{"None"}</option>
                                                                {
                                                                    availableVehicleClass?.map((item: any, index: number) => {
                                                                        return <option className={`${themeStyles.main.tailwindSectionBg}`} key={index} value={item?.vehicleClassId}>{item?.vehicleLabel}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>

                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Free Change?</label>
                                                            <RadioGroup
                                                                row
                                                                value={isFreeChange ? "Yes" : "No"}
                                                                onChange={(e) => setIsFreeChange(e.target.value === "Yes" ? true : false)}
                                                            >
                                                                <FormControlLabel
                                                                    value="Yes"
                                                                    control={
                                                                        <Radio
                                                                            sx={{
                                                                                color: "gray",
                                                                                "&.Mui-checked": {
                                                                                    color: "#167AC3",
                                                                                },
                                                                                '& .MuiSvgIcon-root': {
                                                                                    fontSize: 14,
                                                                                },
                                                                            }}
                                                                        />
                                                                    }
                                                                    label="Yes"
                                                                    sx={{
                                                                        color: themeStyles.form.labelTextColor
                                                                    }}
                                                                />

                                                                <FormControlLabel
                                                                    value="No"
                                                                    control={
                                                                        <Radio
                                                                            sx={{
                                                                                color: "gray",
                                                                                "&.Mui-checked": {
                                                                                    color: "#167AC3",
                                                                                },
                                                                                '& .MuiSvgIcon-root': {
                                                                                    fontSize: 14,
                                                                                },
                                                                            }}
                                                                        />
                                                                    }
                                                                    label="No"
                                                                    sx={{
                                                                        color: themeStyles.form.labelTextColor
                                                                    }}
                                                                />
                                                            </RadioGroup>
                                                        </div>

                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Current Odometer</label>
                                                            <input
                                                                type="text"
                                                                min={summaryData ? summaryData?.odometerAtCheckOut : 0}
                                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                value={newVehicleOdometer}
                                                                onChange={(e) => setNewVehicleOdometer(e.target.value)}
                                                                required
                                                            />
                                                        </div>

                                                    </div>

                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Replacement Vehicle</label>
                                                            <select
                                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                value={selectedVehicle}
                                                                onChange={(e) => {
                                                                    setSelectedVehicle(parseInt(e.target.value))
                                                                }}
                                                                required
                                                            >
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>{"None"}</option>
                                                                {
                                                                    availableVehicle?.map((item: any, index: number) => {
                                                                        return <option className={`${themeStyles.main.tailwindSectionBg}`} key={index} value={item.value}>{item.label}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>

                                                        <div className="mt-[19px]">
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fuel level</label>
                                                            <select
                                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                value={newVehicleFuleLevel}
                                                                onChange={(e) =>
                                                                    setNewVehicleFuleLevel(parseInt(e.target.value))
                                                                }
                                                                required
                                                            >
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>0</option>
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={1}>1</option>
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={2}>2</option>
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={3}>3</option>
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={4}>4</option>
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={5}>5</option>
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={6}>6</option>
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={7}>7</option>
                                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={8}>8</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mt-4 mb-2 w-full">
                                                    <div className="max-w-1/2 flex flex-row items-center gap-[5px] flex-wrap">
                                                        {
                                                            newVehicleFilePath?.map((item: any, outerIndex: number) => (
                                                                <React.Fragment key={outerIndex}>
                                                                    <img
                                                                        src={item.fileName}
                                                                        width={40}
                                                                        height={40}
                                                                        alt="repairOrder"
                                                                        onClick={() => {
                                                                            setNewVehicleFileIndex(outerIndex);
                                                                            setImagePopup(true);
                                                                            setCurrrentPreview('new-vehicle');
                                                                        }}
                                                                    />
                                                                    <RemoveCircleIcon
                                                                        className={`text-[14px] ${themeStyles.main.textSubHeadingColor} font-bold  hover:text-red-500 cursor-pointer`}
                                                                        onClick={() => {
                                                                            setConfirmData({
                                                                                title: 'Delete image',
                                                                                summary: "Are you sure you want to delete this image?",
                                                                                confirmBtn: 'Yes',
                                                                                isConfirm: async (callback: any) => {
                                                                                    let newFileSet: any[] = newVehicleFilePath.filter(
                                                                                        (_, index: number) => index !== outerIndex
                                                                                    );

                                                                                    if (newVehicleFilePath[outerIndex].id === 0) {
                                                                                        setNewVehicleFilePath(() => newFileSet);
                                                                                    } else {
                                                                                        setPleaseWaitPopup(true);

                                                                                        delete_fileUpload(newVehicleFilePath[outerIndex]?.id, auth?.id, tenantId)
                                                                                            .then(() => {
                                                                                                setNewVehicleFilePath(() => newFileSet);
                                                                                                setPleaseWaitPopup(false);
                                                                                                handleTenantError(null);
                                                                                            })
                                                                                            .catch((error) => {
                                                                                                setPleaseWaitPopup(false);
                                                                                                handleTenantError(error);
                                                                                            });
                                                                                    }
                                                                                    callback();
                                                                                }
                                                                            });
                                                                            setConfirmPopup(true);
                                                                        }}
                                                                    />
                                                                </React.Fragment>
                                                            ))
                                                        }
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images</label>
                                                        <input
                                                            type="file"
                                                            name="inputFileRef"
                                                            accept="image/*"
                                                            ref={newInputFileRef}
                                                            onChangeCapture={onNewVehicleFileChangeCapture}
                                                            style={{ display: "none" }}
                                                        />
                                                        <div className="flex flex-row gap-2 mt-2">
                                                            <p
                                                                className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                                onClick={(e) => {
                                                                    if (newInputFileRef.current) {
                                                                        newInputFileRef.current.value = "";
                                                                    }

                                                                    newInputFileRef.current?.click();
                                                                }}
                                                            >
                                                                <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                                Add Image
                                                            </p>

                                                            <p
                                                                className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                                onClick={() => {
                                                                    setShowWebcam(true)
                                                                    setCurrrentWebCam('new-vehicle')
                                                                }}
                                                            >
                                                                <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <span className="w-full text-sm text-red-500">{newInfoMessage}</span>

                                                <div className="w-full mt-4">
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Comments</label>
                                                    <textarea
                                                        className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        rows={4}
                                                        onChange={(e) => setComment(e.target.value)}
                                                        value={comment}
                                                        required
                                                    />
                                                </div>

                                                <div className="mt-4 w-full flex gap-4">
                                                    <Button variant="contained"
                                                        sx={{
                                                            backgroundColor: colorConfigs.btn.main.bg
                                                        }}
                                                        onClick={handleSubmit}
                                                    >
                                                        Save
                                                    </Button>

                                                    <Button variant="contained"
                                                        sx={{
                                                            backgroundColor: colorConfigs.btn.cancel.bg,
                                                            border: colorConfigs.btn.cancel.border,
                                                            color: colorConfigs.btn.cancel.color
                                                        }}
                                                        onClick={() => setReplaceVehicleIsOpen(false)}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog
                open={showWebcam}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '500px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[10px] py-[5px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>WebCam</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <Webcam
                                            width={500}
                                            height={320}
                                            ref={webRef}
                                            screenshotFormat="image/png"
                                            audio={false}
                                        />

                                        <div className="flex gap-4 mt-6">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => setShowWebcam(false)}
                                            >
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                onClick={() => {
                                                    if (currentWebCam === "return-vehicle") {
                                                        if (webRef.current !== null) {
                                                            //@ts-ignore
                                                            const imageSrc = webRef.current.getScreenshot();
                                                            handleCapture(imageSrc, `${baseURL}reservationFile/upload`, tenantId, (imageFilePath: string) => {
                                                                if (imageFilePath) {
                                                                    setReturnVehicleNewFilePath((prevFileString: string[]) => [
                                                                        ...prevFileString,
                                                                        `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                    ]);

                                                                    const newFile: any = {
                                                                        id: 0,
                                                                        fileName: `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                    };
                                                                    setReturnVehicleFilePath((prevFileString: any[]) => [
                                                                        ...prevFileString,
                                                                        newFile,
                                                                    ]);
                                                                }
                                                            })

                                                            setShowWebcam(false);
                                                        }
                                                    } else if (currentWebCam === "new-vehicle") {
                                                        if (webRef.current !== null) {
                                                            //@ts-ignore
                                                            const imageSrc = webRef.current.getScreenshot();

                                                            handleCapture(imageSrc, `${baseURL}reservationFile/upload`, tenantId, (imageFilePath: string) => {
                                                                if (imageFilePath) {
                                                                    setNewVehicleNewFilePath((prevFileString: string[]) => [
                                                                        ...prevFileString,
                                                                        `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                    ]);

                                                                    const newFile: any = {
                                                                        id: 0,
                                                                        fileName: `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                    };
                                                                    setNewVehicleFilePath((prevFileString: any[]) => [
                                                                        ...prevFileString,
                                                                        newFile,
                                                                    ]);
                                                                }
                                                            })

                                                            setShowWebcam(false);
                                                        }
                                                    }
                                                }}
                                            >
                                                Capture an Image
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={currentPreview === 'return-vehicle' ? returnVehicleFilePath : newVehicleFilePath}
                fileIndex={currentPreview === 'return-vehicle' ? returnVehiclefileIndex : newVehicleFileIndex}
                setFileIndex={currentPreview === 'return-vehicle' ? setReturnVehiclefileIndex : setNewVehicleFileIndex}
                imageBaseUrlPath="reservationFile"
                updateFile={updateFile}
            />
        </>
    )
}

export default AddReplaceVehicleModal;